import { Link } from '@mui/joy';
import { t } from 'i18next';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { InfoCard } from 'core/components';
import { formatDate } from 'core/utils';
import { UpdateJobName } from 'jobs/components';
import { oldBomPartListPath } from 'jobs/routes';
import { IJobNameUpdateForm } from 'jobs/types';
import { IBaseQuote } from 'quotes/types';

interface IProps {
  quote: IBaseQuote;
  updateQuote?: (updatedQuote?: IBaseQuote) => void;
}

export const JobDetails = ({ quote, updateQuote }: IProps) => {
  const [isEditOpen, setIsEditOpen] = useState<boolean>(false);

  const { t } = useTranslation();

  const defaultValues = useMemo(
    () => ({
      jobName: quote.jobName,
    }),
    [quote]
  );

  const onSubmitSuccess = (data: IJobNameUpdateForm) => {
    updateQuote?.({ ...quote, jobName: data.jobName });

    setIsEditOpen(false);
  };

  const items = getParentJobItems(quote);

  return (
    <>
      <InfoCard
        title={t('titleParentJob')}
        items={items}
        onEdit={() => setIsEditOpen(true)}
        isEditable={!!updateQuote}
      />

      <UpdateJobName
        jobId={quote.bomId}
        projectId={quote.vendorProjectId}
        isOpen={isEditOpen}
        onSubmitSuccess={onSubmitSuccess}
        onClose={() => setIsEditOpen(false)}
        defaultValues={defaultValues}
      />
    </>
  );
};

const getParentJobItems = (quote: IBaseQuote) => {
  return [
    {
      label: t('labelJobName'),
      value: quote.jobName,
    },
    {
      label: t('labelCreated'),
      value: formatDate(quote.bomCreatedAt),
    },
    {
      label: t('labelJobId'),
      value: (
        <Link
          target="_blank"
          href={oldBomPartListPath(quote.vendorProjectId ?? quote.customerProjectId, quote.bomId)}
        >
          {quote.bomId}
        </Link>
      ),
    },
  ];
};
